import React, { useEffect } from "react";
import MiniCategoryCard from "./MiniCategoryCard";
import rugIcon from "../../../assets/rug.png";
import useLocation from "../../../hooks/useLocation";

const ServiceCategories = () => {
  const { categories, fetchCategories, loading, error } = useLocation();

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="mt-16 md:mt-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
        Hizmet Kategorileri
      </h2>
      {loading && <p className="text-center text-gray-500">Yükleniyor...</p>}
      {error && <p className="text-center text-red-500">Hata: {error}</p>}
      {!loading && !error && (
        <div className="overflow-x-auto md:overflow-visible -mx-4 px-4 pb-4">
          <div className="flex md:flex-wrap md:justify-center gap-4">
            {categories &&
              categories.map((category) => (
                <div key={category.id} className="flex-shrink-0">
                  <MiniCategoryCard
                    title={category.name}
                    icon={
                      <img
                        src={rugIcon}
                        alt={category.name}
                        className="w-5 h-5"
                      />
                    }
                  />
                </div>
              ))}
          </div>
        </div>
      )}
      {!loading && !error && categories && categories.length === 0 && (
        <p className="text-center text-gray-500">
          Gösterilecek kategori bulunamadı.
        </p>
      )}
    </div>
  );
};

export default ServiceCategories;
